// extracted by mini-css-extract-plugin
module.exports = {"ClientCard":"ClientCard_ClientCard__3VNuv","LeftComponent":"ClientCard_LeftComponent__3onWn","Label":"ClientCard_Label__3B1MZ","NextIcon":"ClientCard_NextIcon__1XXx7"};